export default __webpack_public_path__ + "static/media/driveway2.27da5cdb.jpg";